module.exports = {
  title: 'Page title',
  slogan:
    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
  image: 'https://inno-ecl.s3.amazonaws.com/media/examples/example-image.jpg',
  isHomepage: true,
};
